import { Input, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import YourGuidePage from "./YourGuidePage";
import "../../../styles/preparation.css";
import Icon from "../../../assets/Icon";
import { Link } from "react-router-dom";
import Utils from "../../../utils/Utils";
import { getModuleAccessInfoApi } from "../../../api/candidate";
import WebUtils from "../../../utils/WebUtils";
import RequestAccess from "../../requestAccess/RequestAccess";
import Loader from "../../Loader";
import NoCreditModal from "./NoCreditModal";
import { HelpCircle } from "lucide-react";

const userDetail = Utils.getUserDetail();

function PreparationLandingPage({ setSelectedTab }) {
  const [guideDataFlag, setGuideDataFlag] = useState(null);
  const [clearResultsFlag, setClearResultsFlag] = useState(false);
  const [notFoundFlag, setNotFoundFlag] = useState(false);
  const [preparationGuideStatus, setPreparationGuideStatus] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [jobGuideFilters, setJobGuideFilters] = useState(
    "SORT_BY_CREATION_DATE"
  );
  const [moduleInfo, setModuleInfo] = useState();
  const [loading, setLoading] = useState(false);
  const [creditModalFlag, setCreditModalFlag] = useState(false);

  const getModuleInfo = async () => {
    const url = `${getModuleAccessInfoApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setModuleInfo(result.data.data);
          // setModuleInfo((prev) => ({ ...prev, credits: 0 }));
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const handleStatusChange = (value) => {
    setPreparationGuideStatus(value);
  };
  const handleSortChange = (value) => {
    setJobGuideFilters(value);
  };
  const handleSearch = () => {
    setClearResultsFlag(false);
    setSearchButtonText(searchText);
  };
  const handleClearSearch = () => {
    setClearResultsFlag(true);
    setSearchText("");
    setSearchButtonText("");
  };

  useEffect(() => {
    getModuleInfo();
  }, []);

  return (
    <>
      {loading && <Loader />}
      {creditModalFlag && (
        <NoCreditModal
          creditModalFlag={creditModalFlag}
          setCreditModalFlag={setCreditModalFlag}
        />
      )}
      {moduleInfo?.hasPreparationGuideAccess && (
        <div className=" preparation-container">
          <div className="w-full flex justify-between flex-col lg:flex-row gap-4 ">
            {notFoundFlag || (guideDataFlag && guideDataFlag.length > 0) ? (
              <>
                <div className="flex-1 mt-[1rem] flex flex-wrap gap-2 driver-all-guide-search">
                  <Input
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="w-[300px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
                    prefix={<Icon type="search-icon" />}
                    // size="large"
                    placeholder="Search"
                    onPressEnter={handleSearch}
                  />
                  <div className="flex gap-2">
                    <button
                      className="w-[105px] btn-orange py-[0.35rem] px-[1rem] text-[.9rem]"
                      onClick={handleSearch}
                    >
                      Search
                    </button>
                    {searchButtonText && (
                      <button
                        className="w-[135px] btn-white py-[0.35rem] px-[1rem] text-[.9rem]"
                        onClick={handleClearSearch}
                      >
                        Clear Results
                      </button>
                    )}
                  </div>
                  <div className="flex items-start gap-3 flex-wrap">
                    <Select
                      className="driverjs-all-guide-status-filter"
                      defaultValue="All"
                      suffixIcon=<svg
                        width="15"
                        height="15"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                          stroke="#344054"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      style={{
                        width: 90,
                      }}
                      onChange={handleStatusChange}
                      options={[
                        {
                          value: "All",
                          label: "All",
                        },
                        {
                          value: "Active",
                          label: "Active",
                        },
                        {
                          value: "Draft",
                          label: "Draft",
                        },
                      ]}
                    />
                    <Select
                      className="driverjs-all-guide-date-filer"
                      defaultValue="SORT_BY_CREATION_DATE"
                      suffixIcon=<svg
                        width="15"
                        height="15"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 10H15M2.5 5H17.5M7.5 15H12.5"
                          stroke="#344054"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      style={{
                        width: 150,
                      }}
                      onChange={handleSortChange}
                      options={[
                        {
                          value: "SORT_BY_CREATION_DATE",
                          label: "Sort by date",
                        },
                        {
                          value: "SORT_BY_COMPANY_NAME",
                          label: "Sort by company",
                        },
                        {
                          value: "SORT_BY_JOB",
                          label: "Sort by job",
                        },
                      ]}
                    />
                    {moduleInfo?.credits > 0 ? (
                      <Link to="/create-jd" className="">
                        <button className="btn-orange py-[0.35rem] px-[0.9rem] text-[.9rem]">
                          + Create new
                        </button>
                      </Link>
                    ) : (
                      <button
                        onClick={() => setCreditModalFlag(true)}
                        className="btn-orange py-[.35rem] px-[0.9rem] text-[.9rem]"
                      >
                        + Create new
                      </button>
                    )}
                  </div>
                </div>
                <div className="w-fit flex justify-end items-center gap-y-2 gap-x-3">
                  <div className="flex gap-1 items-center justify-center text-[.83rem] font-semibold border border-[#FEC84B] bg-[#FFFAEB] text-[#0F1B23] rounded-full hover-effect px-3 py-[.2rem]">
                    Guide Credits:{" "}
                    {moduleInfo?.credits > 0 ? (
                      <span className="text-green-600 font-mono text-[.98rem] font-semibold">
                        {moduleInfo?.credits}
                      </span>
                    ) : (
                      <span className="text-red-500 font-mono text-[1rem] font-semibold">
                        {moduleInfo?.credits}
                      </span>
                    )}
                    <Tooltip
                      title={
                        <>
                          <div className="font-medium text-center text-[.88rem] text-orangish">
                            Credits Left:{" "}
                            <span className="font-bold ">
                              {moduleInfo?.credits}
                            </span>
                          </div>
                          <div className="text-white text-center">
                            This shows the number of credits you have left to
                            create guides.
                          </div>
                        </>
                      }
                      overlayInnerStyle={{
                        padding: "10px 14px",
                        background: "#0F1B23",
                      }}
                    >
                      <HelpCircle size={19} className="ml-1 cursor-pointer" />
                    </Tooltip>
                  </div>
                  <Link to={"/credits"}>
                    <button className="py-[.35rem] px-[.9rem] text-[.9rem] btn-orange">
                      Buy Credits
                    </button>
                  </Link>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>

          <YourGuidePage
            setSelectedTab={setSelectedTab}
            guideDataFlag={guideDataFlag}
            setNotFoundFlag={setNotFoundFlag}
            notFoundFlag={notFoundFlag}
            setGuideDataFlag={setGuideDataFlag}
            preparationGuideStatus={preparationGuideStatus}
            jobGuideFilters={jobGuideFilters}
            searchButtonText={searchButtonText}
            clearResultsFlag={clearResultsFlag}
            moduleInfo={moduleInfo}
          />
        </div>
      )}
      {moduleInfo?.hasPreparationGuideAccess === false && (
        <RequestAccess moduleName="PREPARATION_GUIDES" />
      )}
    </>
  );
}

export default PreparationLandingPage;
